import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getEstablishmentAssignationList,
	addNewEstablishmentAssignation,
	updateEstablishmentAssignation,
	deleteEstablishmentAssignation,
	getEstablishmentAssignation,
} from '../establishmentAssignation/thunk';

export const initialState = {
	itemEstablishmentAssignationList: [],
	itemEstablishmentAssignationDetail: null,
	isEstablishmentAssignationLoading: false,
	isEstablishmentAssignationSuccess: false,

	dataEstablishmentAssignation: null,
	establishmentAssignationList: [],
	establishmentAssignationListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReceiving: false,
	isReceived: false,
	isReceptionError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};

const EstablishmentAssignationSlice = createSlice({
	name: 'EstablishmentAssignations',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		// cleanDataEstablishmentAssignation(state, action) {
		// 	state.dataEstablishmentAssignation = null;
		// },
		// restartRegisterEstablishmentAssignation(state, action) {
		// 	state.isAdding = false;
		// 	state.isAdded = false;
		// 	state.registerDisabled = false;
		// },
	},
	extraReducers: builder => {
		builder.addCase(getEstablishmentAssignation.fulfilled, (state, action) => {
			state.isEstablishmentAssignationLoading = false;
			state.isEstablishmentAssignationSuccess = true;
			state.itemEstablishmentAssignationDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getEstablishmentAssignation.pending, state => {
			state.isEstablishmentAssignationLoading = true;
			state.isEstablishmentAssignationSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEstablishmentAssignation.rejected, (state, action) => {
			state.isEstablishmentAssignationLoading = false;
			state.isEstablishmentAssignationSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getEstablishmentAssignationList.pending, state => {
			state.isEstablishmentAssignationSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEstablishmentAssignationList.fulfilled, (state, action) => {
			state.itemEstablishmentAssignationList = action.payload;
			state.establishmentAssignationList = action.payload;
			state.isLoadingList = false;
			state.isEstablishmentAssignationSuccess = true;

			let establishmentAssignationListSelect = [];
			action.payload.map(item =>
				establishmentAssignationListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.establishmentAssignationListSelect = establishmentAssignationListSelect;
		});
		builder.addCase(getEstablishmentAssignationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isEstablishmentAssignationSuccess = true;
		});
		builder.addCase(addNewEstablishmentAssignation.fulfilled, (state, action) => {
			state.itemEstablishmentAssignationList.push(action.payload);
			state.establishmentAssignationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewEstablishmentAssignation.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewEstablishmentAssignation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateEstablishmentAssignation.fulfilled, (state, action) => {
			state.itemEstablishmentAssignationList = state.itemEstablishmentAssignationList.map(establishmentAssignation =>
				establishmentAssignation.establishmentAssignationname === action.payload.old_establishmentAssignation
					? { ...establishmentAssignation, ...action.payload.updated_establishmentAssignation }
					: establishmentAssignation
			);
			state.establishmentAssignationList = state.establishmentAssignationList.map(establishmentAssignation =>
				establishmentAssignation._id.toString() === action.payload._id.toString()
					? { ...establishmentAssignation, ...action.payload }
					: establishmentAssignation
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateEstablishmentAssignation.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateEstablishmentAssignation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteEstablishmentAssignation.fulfilled, (state, action) => {
			state.itemEstablishmentAssignationList = current(state.itemEstablishmentAssignationList).filter(
				item => item._id !== action.payload._id
			);
			state.establishmentAssignationList = current(state.establishmentAssignationList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteEstablishmentAssignation.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteEstablishmentAssignation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	cleanDataEstablishmentAssignation,
	restartRegisterEstablishmentAssignation
} = EstablishmentAssignationSlice.actions;

export default EstablishmentAssignationSlice.reducer;